<template>
  <transition name="fade">
    <tr v-if="formOpened" class="message">
      <form-item-label label="メッセージ" :required="true">
        <br />
        <a @click.prevent="openModal"><small>文例を見る</small></a>
      </form-item-label>
      <td colspan="3">
        <div class="m3p-contact__input m3p-contact__message">
          <textarea-field
            v-model="textareaValue"
            :label="fieldName"
            type="textarea"
            :name="fieldName"
            placeholder="400文字以内でご要望・ご質問内容をご入力ください。"
            :validator="validator"
            :dispatcher="dispatcher"
          />
          <error-message :name="fieldName" />
        </div>
      </td>
    </tr>
  </transition>
</template>

<script setup>
import { ref } from 'vue';
import FormItemLabel from '@component_path/pages/pc/positions/show/common_components/form_element/FormItemLabel';
import TextareaField from '@component_path/pages/common/form/element/textarea';
import ErrorMessage from '@component_path/pages/pc/positions/show/common_components/form_element/ErrorMessage';
import { useMessageField } from '@component_path/inquiry_form_common_module/custom_hook/Message';

const emit = defineEmits(['on-open-modal']);
const textareaValue = defineModel('textareaValue');

const props = defineProps({
  formOpened: {
    type: Boolean,
    required: true
  }
});

const { fieldName, validator } = useMessageField(true, {
  max: 'コメントは400文字以内にしてください',
  requirement: 'コメントは必須項目です'
});
const dispatcher = ref('positionInquiryMail/setMessage');

const openModal = () => {
  emit('on-open-modal');
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.4s ease-in-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0.4;
}
</style>
